module.exports = __webpack_public_path__ + "media/site_templates/www.doorinstallation.company/images/our_services_1-b655cadac8133b5ac8481b3c4d14dec2.jpg";